import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { HTTPService } from 'src/app/main/services/HTTPService';
import CONFIG from 'src/app/main/urls/urls';

@Component({
  selector: 'app-renew',
  templateUrl: './renew.component.html',
  styleUrls: ['./renew.component.css']
})
export class RenewComponent implements OnInit {

  renewalForm: FormGroup;
  members$: any[] = [];
  books$: any[] = [];
  loading = false;
  submitted = false;

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private httpService: HTTPService,
    private activeModal: NgbActiveModal
  ) {}

  closeModal(): void {
    this.activeModal.dismiss();
  }

  ngOnInit() {
    this.renewalForm = this.fb.group({
      member: ['', Validators.required],
      // Array of selected book IDs
      itemBarcodes: [[], Validators.required],
      renewalDueDate: ['', Validators.required],
      forgiveFines: ['', Validators.required],
    });

    this.getMembers();
    this.getBooks();
  }

  getMembers() {
    this.loading = true;
    this.httpService.getAll(CONFIG.URL_BASE + '/member/all').subscribe(
      (data: any[]) => {
        this.members$ = data;
        this.loading = false;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        console.error('Error fetching members:', err.message);
      }
    );
  }

  getBooks() {
    this.loading = true;
    this.httpService.getAll(CONFIG.URL_BASE + '/book/all').subscribe(
      (data: any[]) => {
        this.books$ = data;
        this.loading = false;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        console.error('Error fetching books:', err.message);
      }
    );
  }

  renew() {
    this.submitted = true;

    if (!this.validateRenewalForm()) {
      return;
    }

    const formValue = this.renewalForm.value;
    const selectedBookIds: number[] = formValue.itemBarcodes.map((id: any) => parseInt(id));
    const selectedBooks = this.books$.filter(book => selectedBookIds.includes(book.id));

    if (selectedBooks.length === 0) {
      this.toastr.error('No valid items selected.');
      return;
    }

    const statusName = 'Renew';
    const memberId = formValue.member;

    const updates = selectedBooks.map(book =>
      this.httpService
        .updateCirculationStatus(String(book.id), String(memberId), statusName)
        .toPromise()
    );

    Promise.all(updates)
      .then(() => {
        this.toastr.success(`${selectedBooks.length} item(s) renewed successfully.`);
        this.closeModal();
      })
      .catch(err => {
        console.error('Renewal error:', err);
        this.toastr.error('An error occurred during renewal.');
      });
  }

  validateRenewalForm(): boolean {
    if (!this.renewalForm) {
      this.toastr.error('Form is not initialized.');
      return false;
    }

    const formValue = this.renewalForm.value;

    if (!formValue.member) {
      this.toastr.error('Please select a member.');
      return false;
    }

    if (!formValue.itemBarcodes || formValue.itemBarcodes.length === 0) {
      this.toastr.error('Please select at least one item barcode.');
      return false;
    }

    if (!formValue.renewalDueDate) {
      this.toastr.error('Please select a renewal due date.');
      return false;
    }

    const renewalDueDate = new Date(formValue.renewalDueDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (renewalDueDate < today) {
      this.toastr.error('Renewal due date cannot be in the past.');
      return false;
    }

    if (!['yes', 'no'].includes(formValue.forgiveFines)) {
      this.toastr.error('Please select a valid option for forgiving fines.');
      return false;
    }

    return true;
  }
}